import { useMemo } from "react";
import { useGetTransactionsListQuery } from "src/entities/transactions/api/api";
import { mapTransactionDtoToRow } from "../../../entities/transactions/model/mappers";
import { TransactionsQuery } from "../../../entities/transactions/model/types";

export function useTransactionsQuery(query: TransactionsQuery) {
  const result = useGetTransactionsListQuery(query);

  const data = useMemo(() => {
    if (!result.data) {
      return {
        data: [],
        meta: {
          total: 0,
          current_page: 1,
          per_page: query.per_page ?? 25,
        },
      };
    }

    return {
      data: result.data.data.map(mapTransactionDtoToRow),
      meta: {
        total: result.data.meta.total,
        current_page: result.data.meta.current_page,
        per_page: result.data.meta.per_page,
      },
    };
  }, [result.data, query.per_page]);

  return {
    ...result,
    data,
  };
}
